import { render, staticRenderFns } from "./OnBoardingMeetingSteps.vue?vue&type=template&id=5978174c&"
import script from "./OnBoardingMeetingSteps.vue?vue&type=script&lang=js&"
export * from "./OnBoardingMeetingSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports